import { api } from './api';

/**
 * Fetch all EV Dashboard data (charts, Sankey, ESG, etc.) from the backend.
 */
export const getEVDashboardData = async () => {
  const response = await api.get('/api/ev-dashboard');
  if (!response.data?.success) throw new Error(response.data?.detail || 'Failed to load EV dashboard');
  return response.data.data;
};
